<template>
  <div class="main-footer">
    <div class="container">
      <div class="row">
        <div class="col-xl-9">
          <h3
            v-t="'c.mainFooter.title.about'"
            class="main-footer__headline"
          />
          <div class="row">
            <ul class="col-xl-4">
              <li
                v-for="(link, index) in links[currentLocale].column1"
                :key="index"
              >
                <router-link
                  v-t="link.i18n"
                  :to="{ name: link.routeName }"
                  class="main-footer__link"
                />
              </li>
              <li>
                <a
                  v-t="'c.mainFooter.navigation.bookmarklet'"
                  :href="bookmarklet"
                  class="main-footer__link"
                  @click.prevent="bookmarkletHint"
                />
              </li>
            </ul>

            <ul class="col-xl-4">
              <li
                v-for="(link, index) in links[currentLocale].column2"
                :key="index"
              >
                <router-link
                  v-t="link.i18n"
                  :to="{ name: link.routeName }"
                  class="main-footer__link"
                />
              </li>
            </ul>

            <ul class="col-xl-4">
              <li
                v-for="(link, index) in links[currentLocale].column3"
                :key="index"
              >
                <router-link
                  v-t="link.i18n"
                  :to="{ name: link.routeName }"
                  class="main-footer__link"
                />
              </li>
            </ul>
          </div>
        </div>
        <div class="col-xl-3">
          <h3
            v-t="'c.mainFooter.title.language'"
            class="main-footer__headline"
          />
          <locale-switch />
        </div>
      </div>

      <div class="main-footer__copyright">
        <svg
          width="42"
          height="42"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            fill="none"
            fill-rule="evenodd"
          >
            <path
              fill="#FEFEFE"
              d="M21.09 17.203v-3.094H12.43v13.612h17.324V17.203z"
            />
            <path
              stroke="#FEFEFE"
              d="M14.131.732V.5h13.612c5.881 0 9.727 2.487 11.871 6.635.757 1.465 1.247 3.041 1.524 4.633.174.998.236 1.824.237 2.363v13.612c0 5.881-2.488 9.727-6.635 11.871-1.465.757-3.041 1.247-4.633 1.524-.998.174-1.824.236-2.364.237H14.131c-5.88 0-9.726-2.488-11.87-6.635-.757-1.465-1.248-3.041-1.525-4.633C.563 29.109.5 28.283.5 27.743V14.131c0-5.88 2.487-9.726 6.635-11.87 1.465-.757 3.04-1.248 4.633-1.524C12.766.563 13.588.5 14.131.5v.232zm0 0V1.5.732z"
            />
          </g>
        </svg>
        <span>2018 Foldaz Technologies GmbH</span>
      </div>
    </div>
  </div>
</template>

<script>
import localeSwitch from '@/components/app/LocaleSwitch'

export default {
  name: 'MainFooter',
  components: {
    localeSwitch
  },
  data () {
    return {
      links: {
        de: {
          column1: [
            // {routeName: 'StaticAboutDE', i18n: 'c.mainFooter.navigation.about'},
            // {routeName: 'StaticHowToUseDE', i18n: 'c.mainFooter.navigation.howToUse'}
          ],
          column2: [
            // {routeName: 'StaticContactDE', i18n: 'c.mainFooter.navigation.contact'},
            {routeName: 'StaticImprintDE', i18n: 'c.mainFooter.navigation.imprint'},
          ],
          column3: [
            // {routeName: 'StaticTermsDE', i18n: 'c.mainFooter.navigation.tos'},
            {routeName: 'StaticPrivacyDE', i18n: 'c.mainFooter.navigation.privacy'}
          ]
        },
        en: {
          column1: [
            // {routeName: 'StaticAboutEN', i18n: 'c.mainFooter.navigation.about'},
            // {routeName: 'StaticHowToUseEN', i18n: 'c.mainFooter.navigation.howToUse'}
          ],
          column2: [
            // {routeName: 'StaticContactEN', i18n: 'c.mainFooter.navigation.contact'},
            {routeName: 'StaticImprintEN', i18n: 'c.mainFooter.navigation.imprint'},
          ],
          column3: [
            // {routeName: 'StaticTermsEN', i18n: 'c.mainFooter.navigation.tos'},
            {routeName: 'StaticPrivacyEN', i18n: 'c.mainFooter.navigation.privacy'}
          ]
        }
      }
    }
  },
  computed: {
    currentLocale () {
      return this.$locale.current()
    },
    bookmarklet () {
      const host = process.env.FOLDAZ_BASE

      return "javascript:window.open('" + host + "/stream?url='+encodeURIComponent(location.href), 'foldaz')"
    }
  },
  methods: {
    bookmarkletHint () {
      alert('bookmarklet!')
    }
  }
}
</script>

<style lang="sass" scoped>
@import '~styles/imports'

.main-footer
  +font-size(14, 24)
  padding: rem-calc(140 0)
  background: $color-black
  color: $color-white

  &__headline
    +font-size(21, 21)
    border-bottom: 1px solid $color-border-3
    padding-bottom: rem-calc(28)
    margin-bottom: rem-calc(28)

  &__link
    color: $color-white

  &__copyright
    display: flex
    flex-direction: row
    align-items: center

    border-top: 1px solid $color-border-3
    margin: rem-calc(30 0)
    padding: rem-calc(28 0)

    svg
      margin-right: rem-calc(15)

</style>



// WEBPACK FOOTER //
// src/components/layout/MainFooter.vue